import * as React from 'react';
import { DiscoveryCardContentSize, DiscoveryContainerType, DiscoveryOfferingType, DiscoveryRecommendationInputContext, DiscoveryRecommendationStrategy, LineOfBusinessDomain, RecommendationsModule } from '@shared-ui/retail-recommendation-module';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import CarouselContext from 'src/common/stores/contexts/carousel-context-provider';
import { ConfigurationIdentifiers } from 'src/common/constants/configuration-identifiers';
import { EgRecsPlacementIds } from 'src/common/constants/eg-recs-placements';
import { DiscoveryPriceStrategy } from 'src/common/__generated__/api';
import { SharedUiSimilarPropertiesWrapper } from '../shared-ui/details/shared-ui-similar-properties';
import { SimpleLazyLoadWrapper } from '../../common/lazy/simple-lazy-load-wrapper';
const PropertyRecsVariantWrapper = ({
  propertyId,
  propertySearchCriteriaInput,
  shoppingContext
}) => {
  var _a, _b, _c;
  const {
    addTopCarouselName
  } = React.useContext(CarouselContext);
  React.useEffect(() => addTopCarouselName('similar-properties'), []);
  const inputProps = {
    inputs: {
      propertyId,
      searchCriteria: propertySearchCriteriaInput,
      shoppingContext
    }
  };
  const {
    checkInDate,
    checkOutDate
  } = (_c = (_b = (_a = inputProps.inputs) === null || _a === void 0 ? void 0 : _a.searchCriteria) === null || _b === void 0 ? void 0 : _b.primary.dateRange) !== null && _c !== void 0 ? _c : {};
  if (!checkInDate || !checkOutDate) {
    return null;
  }
  if (!shoppingContext.multiItem) {
    return React.createElement("div", {
      "data-stid": "property-recs"
    }, React.createElement(Experiment, {
      name: "SmaSh_Property_Recs_New_Carousel"
    }, React.createElement(ExperimentControl, null, React.createElement(SharedUiSimilarPropertiesWrapper, {
      inputs: inputProps.inputs
    })), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(RecommendationsModule, {
      inputs: {
        configurationIdentifier: ConfigurationIdentifiers.LODGING_DATED_PDP_CAROUSEL_FEATURED_HEADER_CHECK,
        contentSize: DiscoveryCardContentSize.LONG_FORM_FEATURED,
        offeringType: DiscoveryOfferingType.PRODUCT,
        strategy: DiscoveryRecommendationStrategy.ALTERNATIVE,
        containerType: DiscoveryContainerType.CAROUSEL,
        priceStrategy: DiscoveryPriceStrategy.LIVE,
        input: [DiscoveryRecommendationInputContext.PRODUCT],
        recommendationContext: {
          outputLineOfBusiness: LineOfBusinessDomain.LODGING,
          pageId: 'HIS',
          lodging: {
            propertyId: String(propertyId),
            checkin: checkInDate,
            checkout: checkOutDate
          }
        },
        placementId: EgRecsPlacementIds.PROPERTY_RECS_PLACEMENT_ID
      }
    }))), React.createElement(ExperimentVariant, {
      bucket: 2
    }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(RecommendationsModule, {
      inputs: {
        configurationIdentifier: ConfigurationIdentifiers.LODGING_DATED_PDP_CAROUSEL_NO_FEATURED_HEADER_CHECK,
        contentSize: DiscoveryCardContentSize.LONG_FORM_FEATURED,
        offeringType: DiscoveryOfferingType.PRODUCT,
        strategy: DiscoveryRecommendationStrategy.ALTERNATIVE,
        containerType: DiscoveryContainerType.CAROUSEL,
        priceStrategy: DiscoveryPriceStrategy.LIVE,
        input: [DiscoveryRecommendationInputContext.PRODUCT],
        recommendationContext: {
          outputLineOfBusiness: LineOfBusinessDomain.LODGING,
          pageId: 'HIS',
          lodging: {
            propertyId: String(propertyId),
            checkin: checkInDate,
            checkout: checkOutDate
          }
        },
        placementId: EgRecsPlacementIds.PROPERTY_RECS_PLACEMENT_ID
      }
    })))));
  }
  return null;
};
export default PropertyRecsVariantWrapper;